//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Haalt de lijst met gebruikersgroepen op.
     * @return Success
     */
    gebruikersgroep_ophalen(gebruikersgroepId: string): Promise<GebruikersgroepenOutput> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/{gebruikersgroepId}";
        if (gebruikersgroepId === undefined || gebruikersgroepId === null)
            throw new Error("The parameter 'gebruikersgroepId' must be defined.");
        url_ = url_.replace("{gebruikersgroepId}", encodeURIComponent("" + gebruikersgroepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroep_ophalen(_response);
        });
    }

    protected processGebruikersgroep_ophalen(response: Response): Promise<GebruikersgroepenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GebruikersgroepenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een gebruikersgroep.
     * @param gebruikersgroepId De identificatie van de gebruikersgroep
     * @param body (optional) De te wijzigen gegevens van de gebruikersgroep
     * @return No Content
     */
    gebruikersgroep_wijzigen(gebruikersgroepId: string, body: Gebruikersgroep | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/{gebruikersgroepId}";
        if (gebruikersgroepId === undefined || gebruikersgroepId === null)
            throw new Error("The parameter 'gebruikersgroepId' must be defined.");
        url_ = url_.replace("{gebruikersgroepId}", encodeURIComponent("" + gebruikersgroepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroep_wijzigen(_response);
        });
    }

    protected processGebruikersgroep_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert de gegevens van de gebruikersgroep met het betreffende id.
     * @param gebruikersgroepId De identificatie van de gebruikersgroep
     * @return No Content
     */
    gebruikersgroep_verwijderen(gebruikersgroepId: string): Promise<void> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/{gebruikersgroepId}";
        if (gebruikersgroepId === undefined || gebruikersgroepId === null)
            throw new Error("The parameter 'gebruikersgroepId' must be defined.");
        url_ = url_.replace("{gebruikersgroepId}", encodeURIComponent("" + gebruikersgroepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroep_verwijderen(_response);
        });
    }

    protected processGebruikersgroep_verwijderen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt de lijst met gebruikersgroepen op.
     * @param organisatieId (optional) De identificatie van de organisatie
     * @return Success
     */
    gebruikersgroepen_ophalen(organisatieId: string | null | undefined): Promise<GebruikersgroepenOutput> {
        let url_ = this.baseUrl + "/Gebruikersgroepen?";
        if (organisatieId !== undefined && organisatieId !== null)
            url_ += "organisatieId=" + encodeURIComponent("" + organisatieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepen_ophalen(_response);
        });
    }

    protected processGebruikersgroepen_ophalen(response: Response): Promise<GebruikersgroepenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GebruikersgroepenOutput>(null as any);
    }

    /**
     * Maakt een nieuwe gebruikersgroep aan.
     * @param body (optional) De gegevens van de nieuwe gebruikersgroep
     * @return Created
     */
    gebruikersgroep_toevoegen(body: Gebruikersgroep | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Gebruikersgroepen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroep_toevoegen(_response);
        });
    }

    protected processGebruikersgroep_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Zet medewerkers over naar een andere gebruikersgroep en verwijder eventueel de oorspronkelijke gebruikersgroep
     * @param body (optional) 
     * @return No Content
     */
    medewerkers_overzetten_naar_een_andere_gebruikersgroep_(gebruikersgroepIdFrom: string, gebruikersgroepTo: string, body: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/From/{gebruikersgroepIdFrom}/To/{gebruikersgroepTo}";
        if (gebruikersgroepIdFrom === undefined || gebruikersgroepIdFrom === null)
            throw new Error("The parameter 'gebruikersgroepIdFrom' must be defined.");
        url_ = url_.replace("{gebruikersgroepIdFrom}", encodeURIComponent("" + gebruikersgroepIdFrom));
        if (gebruikersgroepTo === undefined || gebruikersgroepTo === null)
            throw new Error("The parameter 'gebruikersgroepTo' must be defined.");
        url_ = url_.replace("{gebruikersgroepTo}", encodeURIComponent("" + gebruikersgroepTo));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkers_overzetten_naar_een_andere_gebruikersgroep_(_response);
        });
    }

    protected processMedewerkers_overzetten_naar_een_andere_gebruikersgroep_(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt alle HDN Nodenummers op van een organisatie.
     * @param organisatieId Identificatie van de organisatie
     * @return Success
     */
    hDN_Nodenummers_van_organisatie_ophalen(organisatieId: string): Promise<HdnNodenummersOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/HdnNodenummers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHDN_Nodenummers_van_organisatie_ophalen(_response);
        });
    }

    protected processHDN_Nodenummers_van_organisatie_ophalen(response: Response): Promise<HdnNodenummersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HdnNodenummersOutput>(null as any);
    }

    /**
     * Haalt het HDN nodenummer op dat geldt voor de gegeven vestiging, indien ingesteld.
     * @param vestigingId Identificatie van de vestiging
     * @return Success
     */
    hDN_Nodenummers_van_vestiging_ophalen(vestigingId: string): Promise<HdnNodenummersOutput> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/HdnNodenummers";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHDN_Nodenummers_van_vestiging_ophalen(_response);
        });
    }

    protected processHDN_Nodenummers_van_vestiging_ophalen(response: Response): Promise<HdnNodenummersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HdnNodenummersOutput>(null as any);
    }

    /**
     * Maakt een nieuw HDN Nodenummers aan.
     * @param organisatieId Identificatie van de organisatie
     * @param body (optional) Gegevens van het HDN nodenummer
     * @return Created
     */
    hDN_Nodenummer_toevoegen(organisatieId: string, body: HdnNodenummer | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/HdnNodenummers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHDN_Nodenummer_toevoegen(_response);
        });
    }

    protected processHDN_Nodenummer_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een HDN nodenummer.
     * @param hdnNodenummerId Identificatie van het HDN nodenummer
     * @param body (optional) Gegevens van het HDN nodenummer
     * @return No Content
     */
    hDN_Nodenummer_wijzigen(hdnNodenummerId: string, body: HdnNodenummer | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/HdnNodenummers/{hdnNodenummerId}";
        if (hdnNodenummerId === undefined || hdnNodenummerId === null)
            throw new Error("The parameter 'hdnNodenummerId' must be defined.");
        url_ = url_.replace("{hdnNodenummerId}", encodeURIComponent("" + hdnNodenummerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHDN_Nodenummer_wijzigen(_response);
        });
    }

    protected processHDN_Nodenummer_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van het HDN nodenummer met de betreffende id.
     * @param hdnNodenummerId Identificatie van het HDN nodenummer
     * @return No Content
     */
    hDN_Nodenummer_verwijderen(hdnNodenummerId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/HdnNodenummers/{hdnNodenummerId}";
        if (hdnNodenummerId === undefined || hdnNodenummerId === null)
            throw new Error("The parameter 'hdnNodenummerId' must be defined.");
        url_ = url_.replace("{hdnNodenummerId}", encodeURIComponent("" + hdnNodenummerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHDN_Nodenummer_verwijderen(_response);
        });
    }

    protected processHDN_Nodenummer_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Activeert het HDN Nodenummer met de betreffende id.
     * @param hdnNodenummerId Identificatie van het HDN nodenummer
     * @return No Content
     */
    hDN_Nodenummer_activeren(hdnNodenummerId: string): Promise<void> {
        let url_ = this.baseUrl + "/HdnNodenummers/{hdnNodenummerId}/Activeren";
        if (hdnNodenummerId === undefined || hdnNodenummerId === null)
            throw new Error("The parameter 'hdnNodenummerId' must be defined.");
        url_ = url_.replace("{hdnNodenummerId}", encodeURIComponent("" + hdnNodenummerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHDN_Nodenummer_activeren(_response);
        });
    }

    protected processHDN_Nodenummer_activeren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft met minimal inspanning aan of de app up is.
     * @return Success
     */
    healthCheck(): Promise<void> {
        let url_ = this.baseUrl + "/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "HEAD",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijderd de bewaarde cache uit het geheugen
     * @return Success
     */
    clearCache(): Promise<void> {
        let url_ = this.baseUrl + "/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "HEAD",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de licentieovereenkomsten van een organisatie.
     * @param organisatieId (optional) De unieke identificatie van de organisatie
     * @return Success
     */
    licentieovereenkomsten_van_organisatie_ophalen(organisatieId: string | null | undefined): Promise<LicentieovereenkomstenOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten?";
        if (organisatieId !== undefined && organisatieId !== null)
            url_ += "organisatieId=" + encodeURIComponent("" + organisatieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomsten_van_organisatie_ophalen(_response);
        });
    }

    protected processLicentieovereenkomsten_van_organisatie_ophalen(response: Response): Promise<LicentieovereenkomstenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentieovereenkomstenOutput>(null as any);
    }

    /**
     * Maakt een licentieovereenkomst voor een bepaald product aan voor de organisatie.
     * @param body (optional) De gegevens van de licentieovereenkomst
     * @return Created
     */
    licentieovereenkomst_toevoegen(body: Licentieovereenkomst | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomst_toevoegen(_response);
        });
    }

    protected processLicentieovereenkomst_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de licentieovereenkomst met het betreffente id.
     * @param licentieovereenkomstId De unieke identificatie van de licentieovereenkomst
     * @return Success
     */
    licentieovereenkomst_ophalen(licentieovereenkomstId: string): Promise<LicentieovereenkomstenOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomst_ophalen(_response);
        });
    }

    protected processLicentieovereenkomst_ophalen(response: Response): Promise<LicentieovereenkomstenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentieovereenkomstenOutput>(null as any);
    }

    /**
     * Werkt de gegevens van een licentieovereenkomst bij.
     * @param licentieovereenkomstId De unieke identificatie van de licentieovereenkomst
     * @param body (optional) De nieuwe gegevens van de licentieovereenkomst
     * @return No Content
     */
    licentieovereenkomst_wijzigen(licentieovereenkomstId: string, body: Licentieovereenkomst | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomst_wijzigen(_response);
        });
    }

    protected processLicentieovereenkomst_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert de licentieovereenkomst
     * @param licentieovereenkomstId Unieke identificatie van de licentieovereenkomst
     * @return No Content
     */
    licentieovereenkomst_verwijderen(licentieovereenkomstId: string): Promise<void> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomst_verwijderen(_response);
        });
    }

    protected processLicentieovereenkomst_verwijderen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Zet de contractvorm van een licentieovereenkomst om van Proef naar Betaald.
     * @param licentieovereenkomstId De unieke identificatie van de licentieovereenkomst
     * @return No Content
     */
    licentieovereenkomst_omzetten_naar_betaald_contract(licentieovereenkomstId: string): Promise<void> {
        let url_ = this.baseUrl + "/Licentieovereenkomst/BetaaldContract/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomst_omzetten_naar_betaald_contract(_response);
        });
    }

    protected processLicentieovereenkomst_omzetten_naar_betaald_contract(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de licenties van een organisatie.
     * @return Success
     */
    licenties_van_organisatie_ophalen(organisatieId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/Licenties";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicenties_van_organisatie_ophalen(_response);
        });
    }

    protected processLicenties_van_organisatie_ophalen(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Geeft de licenties van een medewerker.
     * @return Success
     */
    licenties_van_een_medewerker_ophalen(medewerkerId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Licenties";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicenties_van_een_medewerker_ophalen(_response);
        });
    }

    protected processLicenties_van_een_medewerker_ophalen(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Geeft de licenties van een productsamenstelling.
     * @param licentieovereenkomstId (optional) 
     * @return Success
     */
    licenties_van_productsamenstelling_ophalen(licentieovereenkomstId: string | null | undefined, productsamenstellingId: string): Promise<LicentiesDetailsOutput> {
        let url_ = this.baseUrl + "/Productsamenstelling/{productsamenstellingId}/Licenties?";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        if (licentieovereenkomstId !== undefined && licentieovereenkomstId !== null)
            url_ += "licentieovereenkomstId=" + encodeURIComponent("" + licentieovereenkomstId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicenties_van_productsamenstelling_ophalen(_response);
        });
    }

    protected processLicenties_van_productsamenstelling_ophalen(response: Response): Promise<LicentiesDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesDetailsOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesDetailsOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesDetailsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesDetailsOutput>(null as any);
    }

    /**
     * Maakt een nieuw licentie aan.
     * @param body (optional) De gegevens van de nieuwe licentie
     * @return Created
     */
    licentie_toevoegen(body: Licentie | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Licenties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentie_toevoegen(_response);
        });
    }

    protected processLicentie_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Wijzigt het aantal licenties
     * @return No Content
     */
    aantal_licenties_wijzigen(licentieovereenkomstId: string, productsamenstellingId: string, aantalLicenties: number): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Licentieovereenkomst/{licentieovereenkomstId}/Productsamenstelling/{productsamenstellingId}/Licenties/{aantalLicenties}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        if (aantalLicenties === undefined || aantalLicenties === null)
            throw new Error("The parameter 'aantalLicenties' must be defined.");
        url_ = url_.replace("{aantalLicenties}", encodeURIComponent("" + aantalLicenties));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAantal_licenties_wijzigen(_response);
        });
    }

    protected processAantal_licenties_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de gegevens van de licentie met het betreffende id op.
     * @param licentieId Identificatie van de licentie
     * @return Success
     */
    licentie_ophalen(licentieId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Licenties/{licentieId}";
        if (licentieId === undefined || licentieId === null)
            throw new Error("The parameter 'licentieId' must be defined.");
        url_ = url_.replace("{licentieId}", encodeURIComponent("" + licentieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentie_ophalen(_response);
        });
    }

    protected processLicentie_ophalen(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een licentie.
     * @param licentieId De identificatie van de licentie
     * @param body (optional) De te wijzigen gegevens van de licentie
     * @return No Content
     */
    licentie_wijzigen(licentieId: string, body: Licentie | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Licenties/{licentieId}";
        if (licentieId === undefined || licentieId === null)
            throw new Error("The parameter 'licentieId' must be defined.");
        url_ = url_.replace("{licentieId}", encodeURIComponent("" + licentieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentie_wijzigen(_response);
        });
    }

    protected processLicentie_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de licentie met het betreffende id.
     * @param licentieId De identificatie van de licentie
     * @return No Content
     */
    licentie_verwijderen(licentieId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Licenties/{licentieId}";
        if (licentieId === undefined || licentieId === null)
            throw new Error("The parameter 'licentieId' must be defined.");
        url_ = url_.replace("{licentieId}", encodeURIComponent("" + licentieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentie_verwijderen(_response);
        });
    }

    protected processLicentie_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de licenties van een licentieovereenkomst op.
     * @param licentieovereenkomstId Unieke identificatie van de licentieovereenkomst waarvan de licenties moeten worden opgehaald
     * @return Success
     */
    licenties_van_overeenkomst_ophalen(licentieovereenkomstId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}/Licenties";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicenties_van_overeenkomst_ophalen(_response);
        });
    }

    protected processLicenties_van_overeenkomst_ophalen(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Haalt alle medewerkers op van een organisatie.
     * @param organisatieId Identificatie van de organisatie
     * @return Success
     */
    getMedewerkersVanOrganisatie(organisatieId: string): Promise<MedewerkerExOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/Medewerkers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedewerkersVanOrganisatie(_response);
        });
    }

    protected processGetMedewerkersVanOrganisatie(response: Response): Promise<MedewerkerExOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerExOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerExOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerExOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerExOutput>(null as any);
    }

    /**
     * Haalt de gegevens van de medewerker met betreffende id op.
     * @param medewerkerId Identificatie van de medewerker
     * @return Success
     */
    getMedewerker(medewerkerId: string): Promise<MedewerkerOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedewerker(_response);
        });
    }

    protected processGetMedewerker(response: Response): Promise<MedewerkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een medewerker.
     * @param medewerkerId Identificatie van de medewerker
     * @param body (optional) Gegevens van de medewerker
     * @return No Content
     */
    medewerker_wijzigen(medewerkerId: string, body: MedewerkerEx | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_wijzigen(_response);
        });
    }

    protected processMedewerker_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de medewerker met de betreffende id
     * @param medewerkerId Identificatie van de medewerker
     * @return No Content
     */
    medewerker_verwijderen(medewerkerId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_verwijderen(_response);
        });
    }

    protected processMedewerker_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geef de medewerker met het gegeven e-mailadres.
     * @param emailadres (optional) 
     * @return Success
     */
    getMedewerkerbyEmail(emailadres: string | null | undefined): Promise<MedewerkerOrganisatieOutput> {
        let url_ = this.baseUrl + "/Medewerkers/email?";
        if (emailadres !== undefined && emailadres !== null)
            url_ += "Emailadres=" + encodeURIComponent("" + emailadres) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedewerkerbyEmail(_response);
        });
    }

    protected processGetMedewerkerbyEmail(response: Response): Promise<MedewerkerOrganisatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOrganisatieOutput>(null as any);
    }

    /**
     * Geeft de medewerkergegevens van de huidige ingelogde gebruiker.
     * @return Success
     */
    getMedewerkerCurrent(): Promise<MedewerkerOrganisatieOutput> {
        let url_ = this.baseUrl + "/Medewerkers/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedewerkerCurrent(_response);
        });
    }

    protected processGetMedewerkerCurrent(response: Response): Promise<MedewerkerOrganisatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOrganisatieOutput>(null as any);
    }

    /**
     * Maakt een nieuwe medewerker aan.
     * @param organisatieId Identificatie van de organisatie
     * @param body (optional) Gegevens van de medewerker
     * @return Created
     */
    medewerker_toevoegen(organisatieId: string, body: MedewerkerEx | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/Medewerkers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_toevoegen(_response);
        });
    }

    protected processMedewerker_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Koppelt vestigingen aan een medewerker.
     * @param medewerkerId Identificatie van de medewerker
     * @param body (optional) Identificatie van de vestiging
     * @return Created
     */
    vestigingen_koppelen_aan_medewerker(medewerkerId: string, body: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingen_koppelen_aan_medewerker(_response);
        });
    }

    protected processVestigingen_koppelen_aan_medewerker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt alle vestigingen op van een medewerker.
     * @param medewerkerId Identificatie van de medewerkers
     * @param testRechten (optional) Geeft aan of de klantdossiersrechten op vestiging en organisatie gebruikt moeten worden
     * @return Success
     */
    getVestigingenVanMedewerker(medewerkerId: string, testRechten: boolean | null | undefined): Promise<VestigingenOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen?";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (testRechten !== undefined && testRechten !== null)
            url_ += "testRechten=" + encodeURIComponent("" + testRechten) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVestigingenVanMedewerker(_response);
        });
    }

    protected processGetVestigingenVanMedewerker(response: Response): Promise<VestigingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VestigingenOutput>(null as any);
    }

    /**
     * Koppelt gebruikersgroepen aan een medewerker.
     * @param medewerkerId Identificatie van de medewerker
     * @param body (optional) Identificatie van de vestiging
     * @return Created
     */
    gebruikersgroepen_koppelen_aan_medewerker(medewerkerId: string, body: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepen_koppelen_aan_medewerker(_response);
        });
    }

    protected processGebruikersgroepen_koppelen_aan_medewerker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt alle Gebruikersgroepen op van een medewerker.
     * @param medewerkerId Identificatie van de medewerkers
     * @return Success
     */
    getGebruikersgroepenVanMedewerker(medewerkerId: string): Promise<GebruikersgroepenOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGebruikersgroepenVanMedewerker(_response);
        });
    }

    protected processGetGebruikersgroepenVanMedewerker(response: Response): Promise<GebruikersgroepenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GebruikersgroepenOutput>(null as any);
    }

    /**
     * Koppelt een medewerker aan een vestiging.
     * @param medewerkerId Identificatie van de medewerker
     * @param vestigingId Identificatie van de vestiging
     * @return Created
     */
    medewerker_koppelen_aan_vestiging(medewerkerId: string, vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen/{vestigingId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_koppelen_aan_vestiging(_response);
        });
    }

    protected processMedewerker_koppelen_aan_vestiging(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert koppeling tussen medewerker en vestiging
     * @param medewerkerId Identificatie van de medewerker
     * @param vestigingId Identificatie van de vestiging
     * @return No Content
     */
    medewerker_ontkoppelen_van_vestiging(medewerkerId: string, vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen/{vestigingId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_ontkoppelen_van_vestiging(_response);
        });
    }

    protected processMedewerker_ontkoppelen_van_vestiging(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Koppelt een medewerker aan een gebruikersgroep.
     * @param medewerkerId Identificatie van de medewerker
     * @param gebruikersgroepid Identificatie van de gebruikersgroep
     * @return Created
     */
    medewerker_koppelen_aan_Gebruikersgroep(medewerkerId: string, gebruikersgroepid: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen/{gebruikersgroepid}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (gebruikersgroepid === undefined || gebruikersgroepid === null)
            throw new Error("The parameter 'gebruikersgroepid' must be defined.");
        url_ = url_.replace("{gebruikersgroepid}", encodeURIComponent("" + gebruikersgroepid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_koppelen_aan_Gebruikersgroep(_response);
        });
    }

    protected processMedewerker_koppelen_aan_Gebruikersgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert koppeling tussen medewerker en gebruikersgroep
     * @param medewerkerId Identificatie van de medewerker
     * @param gebruikersgroepid Identificatie van de gebruikersgroep
     * @return No Content
     */
    medewerker_ontkoppelen_van_gebruikersgroep(medewerkerId: string, gebruikersgroepid: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen/{gebruikersgroepid}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (gebruikersgroepid === undefined || gebruikersgroepid === null)
            throw new Error("The parameter 'gebruikersgroepid' must be defined.");
        url_ = url_.replace("{gebruikersgroepid}", encodeURIComponent("" + gebruikersgroepid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerker_ontkoppelen_van_gebruikersgroep(_response);
        });
    }

    protected processMedewerker_ontkoppelen_van_gebruikersgroep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft aan of het gegeven e-mailadres in gebruik is bij een medewerker.
     * @param email Het te controleren e-mailadres
     * @return Success
     */
    eMailadres_in_gebruik(email: string): Promise<EmailInGebruikOutput> {
        let url_ = this.baseUrl + "/Medewerkers/EmailInGebruik/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEMailadres_in_gebruik(_response);
        });
    }

    protected processEMailadres_in_gebruik(response: Response): Promise<EmailInGebruikOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailInGebruikOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailInGebruikOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailInGebruikOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailInGebruikOutput>(null as any);
    }

    /**
     * Haalt alle rechten op van een medewerker.
     * @param medewerkerId Identificatie van de medewerkers
     * @return Success
     */
    getRechtenVanMedewerker(medewerkerId: string): Promise<RechtenOutPut> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Rechten";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRechtenVanMedewerker(_response);
        });
    }

    protected processGetRechtenVanMedewerker(response: Response): Promise<RechtenOutPut> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RechtenOutPut>(null as any);
    }

    /**
     * Nodigt een medewerker uit.
     * @param medewerkerId Identificatie van de medewerker
     * @return Success
     */
    postMedewerkerUitnodiging(medewerkerId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Uitnodiging";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMedewerkerUitnodiging(_response);
        });
    }

    protected processPostMedewerkerUitnodiging(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de Organisaties op met hoofdvestiging en LicentieOvereenkomsten.
     * @return Success
     */
    organisaties_ophalen(): Promise<OrganisatiesExOutput> {
        let url_ = this.baseUrl + "/Organisaties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisaties_ophalen(_response);
        });
    }

    protected processOrganisaties_ophalen(response: Response): Promise<OrganisatiesExOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesExOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesExOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesExOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisatiesExOutput>(null as any);
    }

    /**
     * Maakt een nieuwe organisatie aan.
     * @param body (optional) 
     * @return Created
     */
    organisatie_toevoegen(body: OrganisatieEx | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisaties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatie_toevoegen(_response);
        });
    }

    protected processOrganisatie_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt de gegevens van de organisatie met de betreffende id op.
     * @param organisatieId Identificatie van de organisatie
     * @return Success
     */
    organisatie_ophalen(organisatieId: string): Promise<OrganisatiesOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatie_ophalen(_response);
        });
    }

    protected processOrganisatie_ophalen(response: Response): Promise<OrganisatiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisatiesOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een organisatie.
     * @param organisatieId De identificatie van de organisatie
     * @param body (optional) De te wijzigen gegevens van de organisatie
     * @return No Content
     */
    organisatie_wijzigen(organisatieId: string, body: Organisatie | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatie_wijzigen(_response);
        });
    }

    protected processOrganisatie_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de organisatie met het betreffende id.
     * @param organisatieId De identificatie van de organisatie
     * @return No Content
     */
    organisatie_verwijderen(organisatieId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatie_verwijderen(_response);
        });
    }

    protected processOrganisatie_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft aan of het gegeven KvK-nummer in gebruik is bij een organisatie met een actieve licentieovereenkomst.
     * @param kvKnummer Het (unieke) KvK-nummer van de organisatie
     * @return Success
     */
    kvKNummer_in_gebruik(kvKnummer: string): Promise<KvKnummerInGebruikOutput> {
        let url_ = this.baseUrl + "/Organisaties/KvKnummerInGebruik/{kvKnummer}";
        if (kvKnummer === undefined || kvKnummer === null)
            throw new Error("The parameter 'kvKnummer' must be defined.");
        url_ = url_.replace("{kvKnummer}", encodeURIComponent("" + kvKnummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKvKNummer_in_gebruik(_response);
        });
    }

    protected processKvKNummer_in_gebruik(response: Response): Promise<KvKnummerInGebruikOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvKnummerInGebruikOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvKnummerInGebruikOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvKnummerInGebruikOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KvKnummerInGebruikOutput>(null as any);
    }

    /**
     * Verwijdert het organisatielogo.
     * @return No Content
     */
    organisatie_logo_verwijderen(organisatieId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/Logo";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatie_logo_verwijderen(_response);
        });
    }

    protected processOrganisatie_logo_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Zoeken binnen de organisaties
     * @param soort Criterium waarop gezocht wordt
     * @param q (optional) De zoekstring
     * @return No Content
     */
    organisaties_zoeken(soort: Soort, q: string | null | undefined): Promise<ZoekresultaatOutput> {
        let url_ = this.baseUrl + "/Organisaties/Zoeken/{soort}?";
        if (soort === undefined || soort === null)
            throw new Error("The parameter 'soort' must be defined.");
        url_ = url_.replace("{soort}", encodeURIComponent("" + soort));
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisaties_zoeken(_response);
        });
    }

    protected processOrganisaties_zoeken(response: Response): Promise<ZoekresultaatOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZoekresultaatOutput>(null as any);
    }

    /**
     * Maakt een nieuw product aan.
     * @param body (optional) De gegevens van de nieuwe product
     * @return Created
     */
    product_toevoegen(body: Product | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Producten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduct_toevoegen(_response);
        });
    }

    protected processProduct_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt de producten op.
     * @return Success
     */
    producten_ophalen(): Promise<ProductenOutput> {
        let url_ = this.baseUrl + "/Producten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProducten_ophalen(_response);
        });
    }

    protected processProducten_ophalen(response: Response): Promise<ProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenOutput>(null as any);
    }

    /**
     * Haalt de gegevens van het product met de betreffende id op.
     * @param productId Identificatie van het product
     * @return Success
     */
    product_ophalen(productId: string): Promise<ProductenOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduct_ophalen(_response);
        });
    }

    protected processProduct_ophalen(response: Response): Promise<ProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een product.
     * @param productId De identificatie van het product
     * @param body (optional) De te wijzigen gegevens van het product
     * @return No Content
     */
    product_wijzigen(productId: string, body: Product | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Producten/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduct_wijzigen(_response);
        });
    }

    protected processProduct_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert het product met het betreffende id.
     * @param productId De identificatie van het product
     * @return No Content
     */
    product_verwijderen(productId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Producten/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduct_verwijderen(_response);
        });
    }

    protected processProduct_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de gegevens van het product met de betreffende id op.
     * @param productCode Identificatie van het product
     * @return Success
     */
    product_ophalen_m_b_v__de_productcode(productCode: string): Promise<ProductenOutput> {
        let url_ = this.baseUrl + "/Producten/GetProductByCode/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduct_ophalen_m_b_v__de_productcode(_response);
        });
    }

    protected processProduct_ophalen_m_b_v__de_productcode(response: Response): Promise<ProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenOutput>(null as any);
    }

    /**
     * Voegt een productonderdeel toe aan een product.
     * @param productId Unieke identificatie van een product
     * @param body (optional) Gegevens van het productonderdeel
     * @return Created
     */
    productonderdeel_aanmaken(productId: string, body: Productonderdeel | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productonderdelen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdeel_aanmaken(_response);
        });
    }

    protected processProductonderdeel_aanmaken(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de productonderdelen van een product.
     * @param productId Unieke identificatie van het product
     * @return Success
     */
    productonderdelen_van_product(productId: string): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productonderdelen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelen_van_product(_response);
        });
    }

    protected processProductonderdelen_van_product(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de actieve productonderdelen van een medewerker en product.
     * @param medewerkerId Unieke identificatie van het medewerker
     * @param productId Unieke identificatie van het product
     * @return Success
     */
    productonderdelen_van_medewerker_en_product_ophalen(medewerkerId: string, productId: string): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Producten/{productId}/Productonderdelen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelen_van_medewerker_en_product_ophalen(_response);
        });
    }

    protected processProductonderdelen_van_medewerker_en_product_ophalen(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een productonderdeel
     * @param productId (optional) 
     * @param code (optional) 
     * @return Success
     */
    productonderdeel_ophalen_adhv_Code(productId: string | null | undefined, code: string | null | undefined): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen/GetByCode?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdeel_ophalen_adhv_Code(_response);
        });
    }

    protected processProductonderdeel_ophalen_adhv_Code(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een productonderdeel.
     * @param productonderdeelId Unieke identificatie van het productonderdeel
     * @return Success
     */
    productonderdeel_ophalen(productonderdeelId: string): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdeel_ophalen(_response);
        });
    }

    protected processProductonderdeel_ophalen(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Werkt de gegevens van het productonderdeel bij.
     * @param productonderdeelId Unieke identificatie van het productonderdeel
     * @param body (optional) De gegevens van het productonderdeel
     * @return No Content
     */
    productonderdeel_wijzigen(productonderdeelId: string, body: Productonderdeel | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdeel_wijzigen(_response);
        });
    }

    protected processProductonderdeel_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert een productonderdeel.
     * @param productonderdeelId Unieke identificatie van het productonderdeel
     * @return No Content
     */
    productonderdeel_verwijderen(productonderdeelId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdeel_verwijderen(_response);
        });
    }

    protected processProductonderdeel_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de gegevens van alle productonderdelen.
     * @return Success
     */
    productonderdelen_ophalen(): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelen_ophalen(_response);
        });
    }

    protected processProductonderdelen_ophalen(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een of meerdere productonderdelen.
     * @param productonderdeelIds (optional) Lijst met unieke identificatie van productonderdelen
     * @return Success
     */
    productonderdelen_met_Ids_ophalen(productonderdeelIds: string[] | null | undefined): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen/GetByProductonderdeelIds?";
        if (productonderdeelIds !== undefined && productonderdeelIds !== null)
            productonderdeelIds && productonderdeelIds.forEach(item => { url_ += "productonderdeelIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelen_met_Ids_ophalen(_response);
        });
    }

    protected processProductonderdelen_met_Ids_ophalen(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Koppelt een productonderdeel een aan gebruikersgroep.
     * @param productonderdeelId (optional) 
     * @return No Content
     */
    koppel_productonderdeel_aan_gebruikersgroepen(productonderdeelId: string | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/KoppelProductonderdeelAanGebruikersgroepen?";
        if (productonderdeelId !== undefined && productonderdeelId !== null)
            url_ += "productonderdeelId=" + encodeURIComponent("" + productonderdeelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKoppel_productonderdeel_aan_gebruikersgroepen(_response);
        });
    }

    protected processKoppel_productonderdeel_aan_gebruikersgroepen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Ontkoppelt een gebruikersgroep van een productonderdeel.
     * @param productonderdeelId (optional) 
     * @return No Content
     */
    ontkoppel_gebruikersgroepen_van_productonderdeel(productonderdeelId: string | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/OntkoppelGebruikersgroepenVanProductonderdeel?";
        if (productonderdeelId !== undefined && productonderdeelId !== null)
            url_ += "productonderdeelId=" + encodeURIComponent("" + productonderdeelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOntkoppel_gebruikersgroepen_van_productonderdeel(_response);
        });
    }

    protected processOntkoppel_gebruikersgroepen_van_productonderdeel(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Maakt een nieuwe productsamenstelling aan voor een product.
     * @param productId Unieke identificatie van het product
     * @param body (optional) De gegevens van de nieuwe productsamenstelling
     * @return Created
     */
    productsamenstelling_toevoegen(productId: string, body: Productsamenstelling | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productsamenstellingen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_toevoegen(_response);
        });
    }

    protected processProductsamenstelling_toevoegen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt de productsamenstellingen van het product met betreffende id op.
     * @param productId Unieke identificatie van het product
     * @return Success
     */
    productsamenstelling_ophalen_van_een_product(productId: string): Promise<ProductsamenstellingenOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productsamenstellingen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_ophalen_van_een_product(_response);
        });
    }

    protected processProductsamenstelling_ophalen_van_een_product(response: Response): Promise<ProductsamenstellingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductsamenstellingenOutput>(null as any);
    }

    /**
     * Haalt de gegevens van de productsamenstelling met betreffende id op.
     * @param productsamenstellingId Unieke identificatie van de productsamenstelling
     * @return Success
     */
    productsamenstelling_ophalen(productsamenstellingId: string): Promise<ProductsamenstellingenOutput> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_ophalen(_response);
        });
    }

    protected processProductsamenstelling_ophalen(response: Response): Promise<ProductsamenstellingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductsamenstellingenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een Productsamenstelling.
     * @param productsamenstellingId De identificatie van de Productsamenstelling
     * @param body (optional) De te wijzigen gegevens van het Productsamenstelling
     * @return No Content
     */
    productsamenstelling_wijzigen(productsamenstellingId: string, body: Productsamenstelling | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_wijzigen(_response);
        });
    }

    protected processProductsamenstelling_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de Productsamenstelling met het betreffende id.
     * @param productsamenstellingId De identificatie van het Productsamenstelling
     * @return No Content
     */
    productsamenstelling_verwijderen(productsamenstellingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_verwijderen(_response);
        });
    }

    protected processProductsamenstelling_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Koppelt een productonderdeel aan een productsamenstelling.
     * @return Created
     */
    productsamenstelling_koppelen_aan_productonderdeel(productonderdeelId: string, productsamenstellingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_koppelen_aan_productonderdeel(_response);
        });
    }

    protected processProductsamenstelling_koppelen_aan_productonderdeel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Ontkoppelt een productonderdeel van een samenstelling.
     * @return No Content
     */
    productsamenstelling_ontkoppelen_van_productonderdeel(productonderdeelId: string, productsamenstellingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstelling_ontkoppelen_van_productonderdeel(_response);
        });
    }

    protected processProductsamenstelling_ontkoppelen_van_productonderdeel(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de gegevens voor het registratiescherm voor een nieuwe gebruiker.
     * @return Success
     */
    gegevens_registratescherm_nieuwe_gebruiker_ophalen(): Promise<RegistratieKantoorOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGegevens_registratescherm_nieuwe_gebruiker_ophalen(_response);
        });
    }

    protected processGegevens_registratescherm_nieuwe_gebruiker_ophalen(response: Response): Promise<RegistratieKantoorOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistratieKantoorOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het registratieKantoor-scherm tot een registratie.
     * @param body (optional) Gegevens die ingevuld zijn voor de registratie
     * @return Created
     */
    registratie_aanmaken(body: RegistratieKantoor | null | undefined): Promise<RegistreerkantoorSubscriptionOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistratie_aanmaken(_response);
        });
    }

    protected processRegistratie_aanmaken(response: Response): Promise<RegistreerkantoorSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistreerkantoorSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistreerkantoorSubscriptionOutput>(null as any);
    }

    /**
     * Geeft de gegevens voor het registratiescherm voor een bestaande gebruiker van Adviesbox Classic.
     * @param klantcode De klantcode van de gebruiker uit Adviesbox Classic
     * @param sessietoken Het token dat de gebruiker met Adviesbox Classic heeft opgehaald
     * @return Success
     */
    gegevens_registratescherm_bestaande_gebruiker_ophalen(klantcode: string, sessietoken: string): Promise<RegistratieKantoorOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor/Bestaand?";
        if (klantcode === undefined || klantcode === null)
            throw new Error("The parameter 'klantcode' must be defined and cannot be null.");
        else
            url_ += "klantcode=" + encodeURIComponent("" + klantcode) + "&";
        if (sessietoken === undefined || sessietoken === null)
            throw new Error("The parameter 'sessietoken' must be defined and cannot be null.");
        else
            url_ += "sessietoken=" + encodeURIComponent("" + sessietoken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGegevens_registratescherm_bestaande_gebruiker_ophalen(_response);
        });
    }

    protected processGegevens_registratescherm_bestaande_gebruiker_ophalen(response: Response): Promise<RegistratieKantoorOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistratieKantoorOutput>(null as any);
    }

    /**
     * Registeren.
     * @param productId (optional) 
     * @param body (optional) 
     * @return Created
     */
    registreren(productId: string | null | undefined, body: Registreren | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Registreren?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistreren(_response);
        });
    }

    protected processRegistreren(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * @return Success
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return Success
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Geeft de vestigingen van een bepaalde organisatie.
     * @return Success
     */
    vestigingen_ophalen_van_organisatie(organisatieId: string): Promise<VestigingenOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/Vestigingen";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingen_ophalen_van_organisatie(_response);
        });
    }

    protected processVestigingen_ophalen_van_organisatie(response: Response): Promise<VestigingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VestigingenOutput>(null as any);
    }

    /**
     * Maakt een vestiging aan onder een bepaalde organisatie.
     * @param organisatieId De identificatie van de organisatie
     * @param body (optional) De gegevens van de vestiging
     * @return Created
     */
    vestiging_toevoegen_aan_organisatie(organisatieId: string, body: Vestiging | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/Vestigingen";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestiging_toevoegen_aan_organisatie(_response);
        });
    }

    protected processVestiging_toevoegen_aan_organisatie(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de (basisgegevens van de) vestiging met een bepaalde identificatie.
     * @return Success
     */
    vestiging_ophalen(vestigingId: string): Promise<VestigingenOutput> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestiging_ophalen(_response);
        });
    }

    protected processVestiging_ophalen(response: Response): Promise<VestigingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VestigingenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een vestiging.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De nieuwe gegevens van de vestiging
     * @return No Content
     */
    vestiging_wijzigen(vestigingId: string, body: Vestiging | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestiging_wijzigen(_response);
        });
    }

    protected processVestiging_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert de gegevens van een vestiging.
     * @param vestigingId Identificatie van de vestiging
     * @return No Content
     */
    vestiging_verwijderen(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestiging_verwijderen(_response);
        });
    }

    protected processVestiging_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Maakt de gegeven vestiging de hoofdvestiging van de organisatie waaronder de vestiging valt.
     * @param vestigingId De identificatie van de vestiging
     * @return No Content
     */
    hoofdvestiging_van_organisatie_wijzigen(vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Hoofdvestiging";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHoofdvestiging_van_organisatie_wijzigen(_response);
        });
    }

    protected processHoofdvestiging_van_organisatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert het postadres van de vestiging.
     * @param vestigingId Identificatie van de vestiging
     * @return No Content
     */
    postadres_van_vestiging_verwijderen(vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Postadres";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostadres_van_vestiging_verwijderen(_response);
        });
    }

    protected processPostadres_van_vestiging_verwijderen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Kent de connectionstring van de hoofdvestiging opnieuw toe aan de vestiging.
     * @return No Content
     */
    connectionstring_van_de_hoofdvestiging_opnieuw_toekennen(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Connection";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConnectionstring_van_de_hoofdvestiging_opnieuw_toekennen(_response);
        });
    }

    protected processConnectionstring_van_de_hoofdvestiging_opnieuw_toekennen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haal de medewerkers van een vestiging op.
     * @return Success
     */
    medewerkers_van_vestiging_ophalen(vestigingId: string): Promise<MedewerkerOutput> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Medewerkers";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkers_van_vestiging_ophalen(_response);
        });
    }

    protected processMedewerkers_van_vestiging_ophalen(response: Response): Promise<MedewerkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOutput>(null as any);
    }

    /**
     * Verwijder alle klantdossiers van een vestiging
     * @param vestigingId Id van de vestiging waarvan de klantdossiers verwijderd moeten worden
     * @return Success
     */
    klantdossiers_van_vestiging_verwijderen(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Klantdossiers";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKlantdossiers_van_vestiging_verwijderen(_response);
        });
    }

    protected processKlantdossiers_van_vestiging_verwijderen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }
}

/** De gegevens van een adres. */
export interface AdresInput {
    /** De straatnaam */
    straatnaam: string;
    /** Het huisnummer */
    huisnummer: string;
    /** Toevoeging op het huisnummer */
    toevoeging: string | null;
    /** De postcode */
    postcode: string;
    /** Land (identificatie) */
    landCode: string;
    /** Het land */
    land: string;
    /** De plaats */
    plaats: string;
}

export interface BadRequestResult {
    statusCode: number;
}

/** Gegevens contactpersoon voor een kantoor */
export interface Contactpersoon {
    /** Voornaam. */
    voornaam: string | null;
    /** Voorletters. */
    voorletters: string;
    /** Tussenvoegsel. */
    tussenvoegsel: string | null;
    /** Achternaam. */
    achternaam: string;
    geslacht: Geslacht;
    /** E-mail adres. */
    emailadres: string;
    /** E-mail adres bevestiging. */
    emailadresBevestiging: string;
    /** Telefoonnummer. */
    telefoonnummer: string;
}

/** DatabasegrootteOptions _2Gb = 1, _5Gb = 2, _10Gb = 3, _20Gb = 4 */
export enum DatabasegrootteOptions {
    _2Gb = "_2Gb",
    _5Gb = "_5Gb",
    _10Gb = "_10Gb",
    _20Gb = "_20Gb",
}

/** Het resultaat van een de vraag of een e-mailadres in gebruik is. */
export interface EmailInGebruikOutput {
    /** Indicatie dat het e-mailadres in gebruik is bij een medewerker. */
    inGebruik: boolean;
    /** Het medewerkerId van een medewerker. */
    medewerkerId: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Adres voor factuur */
export interface FacturatieGegevens {
    terAttentieVan: string | null;
    straat: string | null;
    huisnummer: string | null;
    toevoeging: string | null;
    postcode: string | null;
    plaats: string | null;
}

/** Bevat gegevens van een gebruikersgroep. */
export interface Gebruikersgroep {
    /** Naam van de Gebruikersgroep */
    naam: string;
    /** Beschrijving van de gebruikersgroep */
    beschrijving: string | null;
    /** ID van de organisatie */
    organisatieId: string;
    /** Gekoppelde product onderdelen */
    productonderdelen: string[] | null;
}

/** Uitvoer van een lijst met gebruikersgroepen (incl. key). */
export interface GebruikersgroepenOutput {
    /** Lijst met gebruikersgroepen (incl. key) */
    gebruikersgroepen: { [key: string]: Gebruikersgroep; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
export enum Geslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}

/** Bevat gegevens van een HDN nodenummer. */
export interface HdnNodenummer {
    /** Nummer van de HDN node (kan voorloopnullen bevatten) */
    nodenummer: string;
    /** Indicatie dat het nodenummer geactiveerd is bij HDN */
    readonly geactiveerd: boolean | null;
    geldigVoor: HdnNodenummerGeldigVoorOptions;
    /** Vestigingen waarvoor het HDN nodenummer geldig is */
    vestigingen: HdnNodenummerVestiging[] | null;
}

/** HdnNodenummerGeldigVoorOptions Vestiging = 1, Organisatie = 2 */
export enum HdnNodenummerGeldigVoorOptions {
    Vestiging = "Vestiging",
    Organisatie = "Organisatie",
}

/** Bevat gegevens van een vestiging waarvoor een HDN nodenummer geldig is. */
export interface HdnNodenummerVestiging {
    /** Het Id van de vestiging. */
    vestigingId: string;
    /** De naam van de vestiging */
    readonly naam: string | null;
}

/** Bevat de output van het opvragen van HDN nodenummers. */
export interface HdnNodenummersOutput {
    /** Collectie met HDN nodenummers met bijbehorend ID */
    hdnNodenummers: { [key: string]: HdnNodenummer; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Ggevens betreffende een kantoor. */
export interface Kantoorgegevens {
    /** Naam Bedrijf */
    bedrijfsnaam: string;
    /** KVK nummer */
    kvkNummer: string;
    /** AFM Nummer */
    afmVergunningsnummer: string | null;
    /** De postcode */
    postcode: string;
    /** Het huisnummer */
    huisnummer: string;
    /** Toevoeging op het huisnummer */
    toevoeging: string | null;
    /** De straatnaam */
    straat: string;
    /** De plaats */
    plaats: string;
    /** Telefoonnummer */
    algemeenTelefoonnummer: string;
    /** Aantal af te nemen licenties */
    aantalLicenties: number;
    databasegrootte: DatabasegrootteOptions;
}

/** KlantdossierRechtenOptions Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
export enum KlantdossierRechtenOptions {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

/** Het resultaat van een de vraag of een KvK-nummer in gebruik is. */
export interface KvKnummerInGebruikOutput {
    /** Indicatie dat het KvK-nummer in gebruik is bij een organisatie met een actieve licentieovereenkomst */
    inGebruik: boolean;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een licentie. */
export interface Licentie {
    /** Unieke identificatie van de licentie binnen het platform. */
    platformId: string | null;
    /** ID van de gekoppelde medewerker */
    medewerkerId: string | null;
    /** ID van het gekoppelde productsamenstelling */
    productsamenstellingId: string;
    /** Naam van de productsamenstelling */
    productsamenstellingNaam: string | null;
    /** ID van de gekoppelde licentieovereenkomst */
    licentieovereenkomstId: string;
}

/** Gegevens van een licentieovereenkomst. */
export interface Licentieovereenkomst {
    /** Is de licentieovereenkomst geblokkeerd, buiten andere regels om (bv. bij wanbetaling) */
    isGeblokkeerd: boolean;
    /** Is de licentieovereenkomst actief */
    isActief: boolean;
    /** Begindatum van de overeenkomst */
    begindatum: string;
    /** Einddatum van de overeenkomst */
    einddatum: string | null;
    licentiesoort: LicentiesoortOpties;
    /** E-mail adres */
    emailFinancieelGemachtigde: string | null;
    /** ID van de gekoppelde organisatie */
    organisatieId: string;
    /** ID van het gekoppelde product */
    productId: string;
    /** Naam van het gekoppelde product */
    productNaam: string | null;
    /** Contractcode */
    contractId: string | null;
    /** Documenten behorende bij de overeenkomst */
    licentieovereenkomstDocumenten: { [key: string]: LicentieovereenkomstDocument; } | null;
}

/** Document behorende bij een licentieovereenkomst. */
export interface LicentieovereenkomstDocument {
    /** id van dit document */
    licentieovereenkomstDocumentId: string;
    /** De naam/titel van dit licentieovereenkomst document. */
    naam: string | null;
    /** De bestandsnaam. */
    bestandsnaam: string | null;
    /** Datum tijd van aanmaken document. */
    aanmaakDatumTijd: string;
    /** Naam van het bestand */
    url: string | null;
}

/** Output van licentieovereenkomsten. */
export interface LicentieovereenkomstenOutput {
    /** Collectie met licentieovereenkomsten. */
    licentieovereenkomsten: { [key: string]: Licentieovereenkomst; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Licentie gegevens van een productsamenstelling */
export interface LicentiesDetails {
    /** Id van de licentie */
    licentieId: string;
    /** Id van de medewerker */
    medewerkerId: string | null;
    medewerker: Medewerker | null;
    /** Opsomming van de vestigingen die aan de medewerker gekoppeld zijn */
    vestiging: string | null;
    /** Einddatum van de licentie */
    einddatum: string | null;
}

/** Uitvoer van een lijst met licentie gegevens van een productsamenstelling */
export interface LicentiesDetailsOutput {
    /** De lijst met lecentiegegevens van een productsamenstelling */
    productsamenstellingLicenties: { [key: string]: LicentiesDetails; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een licentie. */
export interface LicentiesOutput {
    /** Lijst met licenties en hun key */
    licenties: { [key: string]: Licentie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** LicentiesoortOpties Betaald = 0, Proef = 1, Intern = 2 */
export enum LicentiesoortOpties {
    Betaald = "Betaald",
    Proef = "Proef",
    Intern = "Intern",
}

/** Bevat gegevens van een medewerker. */
export interface Medewerker {
    /** Voornaam */
    voornaam: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Achternaam */
    achternaam: string;
    /** Roepnaam */
    roepnaam: string | null;
    /** Voorletters */
    voorletters: string;
    geslacht: Geslacht;
    /** Telefoonnummer */
    telefoon: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Mobiele nummer */
    telefoonMobiel: string | null;
    /** E-mail adres */
    email: string;
    /** Functie */
    functie: string | null;
    /** PlatformId */
    platformId: string | null;
    /** Klantcode */
    klantId: string | null;
    /** Actief */
    isActief: boolean;
    klantdossierRechtenVestigingen: KlantdossierRechtenOptions | null;
    klantdossierRechtenOrganisatie: KlantdossierRechtenOptions | null;
}

/** Medewerker met vestigingen */
export interface MedewerkerEx {
    /** Vestigingen */
    vestigingen: string[] | null;
    /** Gebruikersgroepen */
    gebruikersgroepen: string[] | null;
    /** Productsamenstelling van de licentie */
    productsamenstellingId: string | null;
    /** Naam van de productsamenstelling */
    productsamenstelling: string | null;
    /** Voornaam */
    voornaam: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Achternaam */
    achternaam: string;
    /** Roepnaam */
    roepnaam: string | null;
    /** Voorletters */
    voorletters: string;
    geslacht: Geslacht;
    /** Telefoonnummer */
    telefoon: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Mobiele nummer */
    telefoonMobiel: string | null;
    /** E-mail adres */
    email: string;
    /** Functie */
    functie: string | null;
    /** PlatformId */
    platformId: string | null;
    /** Klantcode */
    klantId: string | null;
    /** Actief */
    isActief: boolean;
    klantdossierRechtenVestigingen: KlantdossierRechtenOptions | null;
    klantdossierRechtenOrganisatie: KlantdossierRechtenOptions | null;
}

/** Output voor MedewerkerEx */
export interface MedewerkerExOutput {
    /** Unieke identificatie van een medewerker */
    medewerkers: { [key: string]: MedewerkerEx; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een medewerker en de organisatie waaraan de medewerker gekoppeld is. */
export interface MedewerkerOrganisatieOutput {
    /** Unieke identificatie van de medewerker. */
    medewerkerId: string;
    medewerker: Medewerker | null;
    /** Unieke identificatie van de organisatie. */
    organisatieId: string;
    /** Naam van de organisatie. */
    readonly organisatieNaam: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor Medewerker */
export interface MedewerkerOutput {
    /** Unieke identificatie van een medewerker */
    medewerkers: { [key: string]: Medewerker; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een organisatie. */
export interface Organisatie {
    /** Naam van de organisatie */
    naam: string;
    /** Unieke identificatie van de organisatie binnen het platform */
    platformId: string | null;
    /** Het KvK-nummer van de organisatie */
    kvKnummer: string | null;
    /** Logo van de organisatie */
    logo: string | null;
    /** IBAN voor incasso */
    iban: string | null;
    /** Het Id van de organisatie. */
    organisatieId: string;
    databasegrootte: DatabasegrootteOptions | null;
}

/** Organisatie en vestiging voor het toevoegen van een nieuwe organisatie (met hoofdvestiging). */
export interface OrganisatieEx {
    vestiging: Vestiging | null;
    /** Licentieovereenkomsten */
    licentieovereenkomsten: Licentieovereenkomst[] | null;
    /** Naam van de organisatie */
    naam: string;
    /** Unieke identificatie van de organisatie binnen het platform */
    platformId: string | null;
    /** Het KvK-nummer van de organisatie */
    kvKnummer: string | null;
    /** Logo van de organisatie */
    logo: string | null;
    /** IBAN voor incasso */
    iban: string | null;
    /** Het Id van de organisatie. */
    organisatieId: string;
    databasegrootte: DatabasegrootteOptions | null;
}

/** Bevat de output van het opvragen van (extended) organisaties. */
export interface OrganisatiesExOutput {
    /** Lijst met organisaties en hun key */
    organisaties: { [key: string]: OrganisatieEx; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de output van het opvragen van organisaties. */
export interface OrganisatiesOutput {
    /** Lijst met organisaties en hun key */
    organisaties: { [key: string]: Organisatie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een product. */
export interface Product {
    /** Naam van het product */
    naam: string;
    /** Code van het product */
    code: string;
    /** Unieke identificatie van het product binnen het platform */
    platformId: string | null;
    /** Status (Actief, Niet actief) */
    isActief: boolean;
    /** Indien 'false' mag het product niet getoond worden in het aanbod waar de gebruiker zelf zijn licentie kan bestellen */
    isOnlineBestelbaar: boolean;
}

/** Producten output. */
export interface ProductenOutput {
    /** Lijst met producten en hun key */
    producten: { [key: string]: Product; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Onderdeel van een product. */
export interface Productonderdeel {
    /** Naam van het productonderdeel. */
    naam: string;
    /** Code van het productonderdeel */
    code: string | null;
    /** Geeft aan of het productonderdeel actief is. */
    isActief: boolean;
    /** Geeft aan of het productonderdeel instelbaar is door de klant. */
    isInstelbaarDoorKlant: boolean;
    /** ID van het gekoppelde product */
    productId: string;
    /** Aantal gekoppelde gebruikersgroepen */
    aantalGekoppeldeGebruikersgroepen: number;
}

/** Uitvoer van een lijst met productonderdelen. */
export interface ProductonderdelenOutput {
    /** De lijst met productonderdelen */
    productOnderdelen: { [key: string]: Productonderdeel; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Complete gegevens van een productsamenstelling. */
export interface Productsamenstelling {
    /** Naam van de product samenstelling */
    naam: string | null;
    /** Code van de product samenstelling */
    code: string | null;
    /** Gekoppeld product */
    productId: string;
    /** Gekoppelde product onderdelen */
    productonderdelen: string[] | null;
    /** Aantal gekoppelde licenties */
    aantalGekoppeldeLicenties: number;
    /** Is de productsamenstelling actief? */
    isActief: boolean;
}

/** Uitvoer van een lijst met productsamenstellingen. */
export interface ProductsamenstellingenOutput {
    /** De lijst met productonderdelen. */
    productSamenstellingen: { [key: string]: Productsamenstelling; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het opvragen van rechten van een medewerker. */
export interface RechtenOutPut {
    /** De rechten van een medewerker */
    rechten: string[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De gegevens van het registratiescherm. */
export interface RegistratieKantoor {
    kantoorgegevens: Kantoorgegevens;
    contactpersoon: Contactpersoon;
    facturatieGegevens: FacturatieGegevens | null;
}

/** Uitvoermodel van registratie kantoor. */
export interface RegistratieKantoorOutput {
    registratieKantoor: RegistratieKantoor | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface RegistreerkantoorSubscriptionOutput {
    /** Unieke ID van de overeenkomst (= naam van Topic Subscription) */
    organisatieId: string;
    /** SAS-token waarmee lees-rechten voor de Topic Subscription verkregen worden */
    readonly sasToken: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van het registratie-form. */
export interface Registreren {
    organisatie: Organisatie | null;
    vestiging: Vestiging | null;
    medewerker: Medewerker | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** Gegevens van de vestiging. */
export interface Vestiging {
    /** De naam van de vestiging */
    naam: string;
    bezoekadres: AdresInput;
    postadres: AdresInput | null;
    /** Het e-mailadres van (de contactpersoon van) de vestiging */
    emailadres: string;
    /** Het telefoonnummer van de vestiging */
    telefoonnummer: string;
    /** Unieke identificatie van de vestiging binnen het platform */
    platformId: string | null;
    /** Het AFM-registratienummer */
    afmRegistratienummer: string;
    /** Geeft aan of dit de hoofdvestiging is */
    isHoofdvestiging: boolean;
    /** Geeft bijbehorende organisatieId aan */
    organisatieId: string | null;
}

/** De uitvoer van een opvraging van een lijst met vestigingen. */
export interface VestigingenOutput {
    /** De gevonden vestigingen */
    vestigingen: { [key: string]: Vestiging; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** ZoekcriteriumOptions Organisatienaam = 0, Postcode = 1, Plaats = 2, KvkNummer = 3 */
export enum ZoekcriteriumOptions {
    Organisatienaam = "Organisatienaam",
    Postcode = "Postcode",
    Plaats = "Plaats",
    KvkNummer = "KvkNummer",
}

/** Een zoekresultaat */
export interface Zoekresultaat {
    organisatie: Organisatie | null;
    hoofdvestiging: Vestiging | null;
}

/** Het resultaat van een zoekopdracht */
export interface ZoekresultaatOutput {
    /** De zoekresultaten */
    readonly zoekresultaten: Zoekresultaat[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Criterium waarop gezocht wordt */
export enum Soort {
    Organisatienaam = "Organisatienaam",
    Postcode = "Postcode",
    Plaats = "Plaats",
    KvkNummer = "KvkNummer",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}